import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-videojob',
  templateUrl: './videojob.component.html',
  styleUrls: ['./videojob.component.css']
})
export class VideojobComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData = `
  curl -X POST https://api.optimusdrive.ai/vod/v1/video/job \
     -H "Content-Type: application/json" \
  -H 'authorization: XXX' \
     -d '{
  "input_url": "https://cmw-demo-videos-bucket.s3.us-east-2.amazonaws.com/1080p/lil_italy.mp4",
  "crunch_mode": "optimizer",
  "input_access_mode": "public",
  "output_access_mode": "public",
  "output_video_codec": "h264",
  "abr_type": "HLS_TS",
  "enable_passthrough": false
}' 

  `

  sucessData = `
  {
    "data": {
      "id": "bdf08885-6447-469c-9935-487de9bc4c4c",
      "created_at": 1690528823,
      "updated_at": 1690528823,
      "input_info": {
        "input_url": "https://cmw-demo-videos-bucket.s3.us-east-2.amazonaws.com/1080p/lil_italy.mp4",
        "filename": "lil_italy.mp4",
        "duration": 0,
        "height": 0,
        "width": 0
      },
      "output_info": {},
      "source": "",
      "source_path": "",
      "crunch_mode": "optimizer",
      "status": "PENDING",
      "output_video_codec": "h264",
      "abr_type": "HLS_TS",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690528823
        }
      ]
    },
    "message": "Job created successfully"
  }`

  Error401x = `
  {
    "message":"Unauthorized"
  }`



}
